import { render, staticRenderFns } from "./healthy.vue?vue&type=template&id=d52b40ae&scoped=true"
import script from "./healthy.vue?vue&type=script&lang=js"
export * from "./healthy.vue?vue&type=script&lang=js"
import style0 from "./healthy.vue?vue&type=style&index=0&id=d52b40ae&prod&lang=scss&scoped=true"
import style1 from "./healthy.vue?vue&type=style&index=1&id=d52b40ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52b40ae",
  null
  
)

export default component.exports